<ion-grid style="width: 100%">
  <ion-row *subscribe="selection$ as selection">
    <ion-col size="12" sizeMd="6">
      <tcc-mono-details-card-layout
        buttonFill="clear"
        iconName="book-section"
        [title]="'Gegevens'"
        (onEdit)="editSelection(selection)"
        (onDelete)="deleteSelection(selection.id)"
        [displayMenu]="!isApp"
        [cardId]="1"
      >
        <ng-container slot="menu">
          <ion-list lines="none">
            <ng-container *ngIf="!isApp">
              <ion-item
                button
                *ngIf="selection?.closed"
                (click)="reopen(selection)"
              >
                <fa-icon
                  slot="start"
                  [icon]="['fal', 'lock-open']"
                  size="xl"
                  [fixedWidth]="true"
                ></fa-icon>
                <ion-label> Heropenen </ion-label>
              </ion-item>
              <ion-item *ngIf="selection?.use_rvo" button (click)="transport(selection)">
                <fa-icon
                  slot="start"
                  [icon]="['fal', 'truck-arrow-right']"
                  size="xl"
                  [fixedWidth]="true"
                ></fa-icon>
                <ion-label> Transport </ion-label>
              </ion-item>
              <ion-item *ngIf="selection?.use_rvo" button (click)="createPassports(selection)">
                <fa-icon
                  slot="start"
                  [icon]="['fal', 'passport']"
                  size="xl"
                  [fixedWidth]="true"
                ></fa-icon>
                <ion-label> Paspoorten aanvragen </ion-label>
              </ion-item>
              <ion-item *ngIf="selection?.use_rvo" button (click)="export(selection)">
                <fa-icon
                  slot="start"
                  [icon]="['fal', 'truck-arrow-right']"
                  size="xl"
                  [fixedWidth]="true"
                ></fa-icon>
                <ion-label> Export </ion-label>
              </ion-item>
              <ion-item
                button
                *ngIf="!selection?.closed"
                (click)="close(selection)"
              >
                <fa-icon
                  slot="start"
                  [icon]="['fal', 'lock']"
                  size="xl"
                  [fixedWidth]="true"
                ></fa-icon>
                <ion-label> Afsluiten </ion-label>
              </ion-item>
              <ion-item button (click)="downloadExcel()">
                <fa-icon
                  slot="start"
                  [icon]="['fal', 'file-excel']"
                  size="xl"
                  [fixedWidth]="true"
                ></fa-icon>
                <ion-label> Download Excel </ion-label>
              </ion-item>
              <ion-item button (click)="downloadExcelByColor()">
                <fa-icon
                  slot="start"
                  [icon]="['fal', 'palette']"
                  size="xl"
                  [fixedWidth]="true"
                ></fa-icon>
                <ion-label> Download Excel Kleuren</ion-label>
              </ion-item>
              <ion-item button (click)="downloadPdf()">
                <fa-icon
                  slot="start"
                  [icon]="['fal', 'file-pdf']"
                  size="xl"
                  [fixedWidth]="true"
                ></fa-icon>
                <ion-label> Download PDF </ion-label>
              </ion-item>
            </ng-container>
          </ion-list>
        </ng-container>
        <tcc-mono-details-table
          *subscribe="rows$ as rows"
          [rows]="rows"
          [firstColumnSize]="4"
          [gridColumnPadding]="8"
        >
        </tcc-mono-details-table>
      </tcc-mono-details-card-layout>
    </ion-col>
    <ion-col *ngIf="!isApp && selection?.use_rvo" size="12" sizeMd="6">
      <tcc-mono-details-card-layout
        [displayActions]="false"
        [title]="'RVO Handelingen'"
        [displayMenu]="false"
        iconName="book-section"
        [cardId]="2"
      >
        <tcc-mono-details-table
          [rows]="rvoCardRows"
          [firstColumnSize]="4"
          [gridColumnPadding]="8"
          [gridColumnPadding]="8"
        >
        </tcc-mono-details-table>
      </tcc-mono-details-card-layout>
    </ion-col>
  </ion-row>
</ion-grid>
